import _, {merge} from "lodash";

export default function mergeStyles(...styles) {
  return merge({}, ..._(styles).flatten().compact().value());
}